module.exports = __webpack_public_path__ + "img/faceberry_nose.b0302919.png";